<div class="">
  <span class="ms-1 chip-label chip--secondary">{{ order.orderNumber }}</span>
</div>
<div>
  <span>{{ order.processedAt | date: 'd-M-yy' }}</span>
</div>
<div class="order-list--hide-mobile">
  <span class="chip-label chip--outline" [ngClass]="order.financialStatus | shopifyStatusColor: 'financial'">
    {{ getLabel('shopify-financialStatus-', order.financialStatus) }}
  </span>
</div>
<div class="order-list--hide-mobile">
  <span>{{ getLabel('shopify-fulfillmentStatus-', order.fulfillmentStatus) }}</span>
</div>
<div>
  <span>{{ order.totalPriceV2.amount | currency: order.totalPriceV2.currencyCode:'symbol':'1.2-2' }}</span>
</div>
